let _timer = null;

const utils = {
  /**
   *
   * @param text
   * @param className
   * @returns {HTMLElement}
   */
  createBox(text = '', className = []) {
    const dom = document.createElement('div');
    dom.innerText = text;

    className.forEach(name => {
      dom.classList.add(name);
    });

    return dom;
  },
  dateToNumber: function (date) {
    if (date instanceof Date) return date.getTime();
    if (typeof date === "string") {
      date.replace(/-/g, '/');
      return new Date(date).getTime();
    }
    if (typeof date === "number") return date;
    throw new Error('参数错误');
  },
  formatNumberToDate: function (date, noZero) {
    date = this.dateToNumber(date || '1999-10-01 00:00:00');

    const diff = date - Date.now();

    if (diff <= 0) {

      if (noZero) {
        return {
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0
        }
      }
      return {
        days: '00',
        hours: '00',
        minutes: '00',
        seconds: '00'
      }
    }

    let
      days = Math.floor(diff / (1000 * 60 * 60 * 24)),
      hours = Math.floor(diff / 1000 / 60 / 60 % 24),
      minutes = Math.floor(diff / 1000 / 60 % 60),
      seconds = Math.floor(diff / 1000 % 60);
    if (!noZero) {
      days = days < 10 ? '0' + days : days.toString();
      hours = hours < 10 ? '0' + hours : hours.toString();
      minutes = minutes < 10 ? '0' + minutes : minutes.toString();
      seconds = seconds < 10 ? '0' + seconds : seconds.toString();
    }

    return {
      days,
      hours,
      minutes,
      seconds
    }
  }
};

// 虚拟dom，性能优化
let vnode = document.createDocumentFragment();

function CountDown(el, options) {
  this.$el = el instanceof HTMLElement ? el : typeof el === 'string' ? document.querySelector(el) : null;
  if (!this.$el) throw new Error('el must be an HTMLElement or a string of strings');

  // 默认配置
  this.$opts = options;

  this.options = Object.assign({}, CountDown.defaults, options);

  const _this = this;

  this.$template = (function (strTemplate) {
    const div = document.createElement('div');
    div.innerHTML = strTemplate;
    _this.options.helperClass && div.children[0].classList.add(_this.options.helperClass);
    return div.innerHTML;
  })(this.options.template);

  this._events = {};

  const _temp = utils.formatNumberToDate(this.options.target, true);
  this.days = _temp.days;
  this.hours = _temp.hours;
  this.minutes = _temp.minutes;
  this.seconds = _temp.seconds;

  this.initWrap();

}

CountDown.defaults = {
  target: `2019/08/01 00:00:00`,
  days: true,
  hours: true,
  width: 60,
  minutes: true,
  seconds: true,
  interval: 1000,
  template: '' +
    '<div class="count">' +
    '  <div class="c c-top">' +
    '    <span class="c-wrap"></span>' +
    '  </div>' +
    '  <div class="c c-bottom">' +
    '    <span class="c-wrap"></span>' +
    '  </div>' +
    '</div>'
};
CountDown.prototype = {
  // 观察者模式
  _on(type, fn) {
    if (!this._events[type]) {
      this._events[type] = [];
    }
    this._events[type].push(fn);
  },
  _off(type, fn) {
    if (!this._events[type]) return;
    const index = this._events[type].indexOf(fn);
    if (index > -1) {
      this._events[type].splice(index, 1);
    }
  },

  _exec(type, data) {
    if (!this._events[type]) return;
    this._events[type].forEach(fn => {
      fn.call(null, data);
    })
  },

  initWrap() {
    this.renderWrap();
    this.start(this.options.interval);

  },
  renderWrap() {
    if (this.options.days) {
      this.$days = utils.createBox('', ['count-wrap', 'count-days']);
      vnode.appendChild(this.$days);
      this.renderItem(this.days, this.$days, 'minutes');
    }
    if (this.options.hours) {
      this.$hours = utils.createBox('', ['count-wrap', 'count-hours']);
      vnode.appendChild(this.$hours);
      this.renderItem(this.hours, this.$hours, 'minutes');
    }
    if (this.options.minutes) {
      this.$minutes = utils.createBox('', ['count-wrap', 'count-minutes']);
      vnode.appendChild(this.$minutes);
      this.renderItem(this.minutes, this.$minutes, 'minutes');
    }
    if (this.options.seconds) {
      this.$seconds = utils.createBox('', ['count-wrap', 'count-seconds']);
      vnode.appendChild(this.$seconds);
      this.renderItem(this.seconds, this.$seconds, 'seconds');
    }

    this.$el.appendChild(vnode);
  },

  // 刷新时间
  refresh(time) {
    this.options.target = time;
    const _temp = utils.formatNumberToDate(time, true);
    this.days = _temp.days;
    this.hours = _temp.hours;
    this.minutes = _temp.minutes;
    this.seconds = _temp.seconds;
    this.increaseCount(_temp);
  },

  renderItem(numbers, el, type) {

    let maxNum;

    numbers = numbers < 10 ? '0' + numbers : numbers + '';

    if (!el.children.length) {
      el.innerHTML = '<div class="c-item" style="width: ' + this.options.width + '"></div><div class="c-item" style="width: ' + this.options.width + '"></div>';

      // 计算时分秒第一位的最大值
      switch (type) {
        case 'seconds':
          maxNum = [5, 9];
          break;
        case 'minutes':
          maxNum = [5, 9];
          break;
        case 'hours':
          let temp = numbers.charAt(0) <= 1 ? 9 : 4;
          maxNum = [2, temp];
          break;
        default:
          maxNum = [9, 9];
          break;
      }

      let nums = null;

      for (let i = 0; i < numbers.length; i++) {
        for (let j = 0; j <= maxNum[i]; j++) {

          // 存放一位数字容器
          const item = el.children[i];

          item.innerHTML += this.$template;

          // 每一位数字
          nums = item.children;

          nums[j].querySelectorAll('.c-wrap').forEach(el => {
            if (this.options.numberPics.length) {
              el.style.backgroundImage = this.options[j];
            } else el.innerHTML = j;
          });
        }

        const prev = parseInt(numbers[i]) + 1 > maxNum[i] ? 0 : parseInt(numbers[i]) + 1;
        const next = numbers[i] - 1 >= 0 ? numbers[i] - 1 : maxNum[i];

        nums[numbers[i]].classList.add('active');
        nums[prev].classList.add('prev');
        nums[next].classList.add('next');
      }

    }
  },

  // 每秒钟执行一次
  eachStep() {
    const changed = {
      days: false,
      hours: false,
      minutes: false,
      seconds: false,
    };

    if (this.hours <= 0 && this.minutes <= 0 && this.seconds <= 0) {
      this._exec('end');
      clearInterval(_timer);
      return true;
    }

    this._exec('change');

    this.seconds--;

    changed.seconds = true;

    if (this.seconds == -1) {
      this.seconds = 59;
      this.minutes--;
      changed.minutes = true;
    }

    if (this.minutes == -1) {
      this.minutes = 59;
      this.hours--;
      changed.hours = true;
    }

    if (this.hours == -1) {
      this.hours = 23;
      this.days--;
      changed.days = true;
    }

    const ob = {};
    for (let i in changed) {
      if (changed[i]) {
        ob[i] = this[i];
      }
      ob[i] = this[i];
    }

    this.increaseCount(ob);

    return false;
  },
  increaseCount(obj) {

    for (let m in obj) {

      let numbers = obj[m] < 10 ? '0' + obj[m] : obj[m] + '';

      const typeEl = this['$' + m];

      if (!typeEl) continue;

      const items = typeEl.children;

      let maxNum = null;

      switch (m) {
        case 'seconds':
          maxNum = [5, 9];
          break;
        case 'minutes':
          maxNum = [5, 9];
          break;
        case 'hours':
          let temp = numbers.charAt(0) <= 1 ? 9 : 4;
          maxNum = [2, temp];
          break;
        default:
          maxNum = [9, 9];
          break;
      }


      // "38"

      for (let i = 0; i < numbers.length; i++) {

        if (i === 0 && numbers[1] != maxNum[1]) continue;

        const counts = items[i].children;

        items[i].querySelector('.active').classList.remove('active');
        items[i].querySelector('.prev').classList.remove('prev');
        items[i].querySelector('.next').classList.remove('next');


        const prev = parseInt(numbers[i]) + 1 > maxNum[i] ? 0 : parseInt(numbers[i]) + 1;
        const next = numbers[i] - 1 >= 0 ? numbers[i] - 1 : maxNum[i];


        counts[numbers[i]].classList.add('active');
        counts[prev].classList.add('prev');
        counts[next].classList.add('next');
      }
    }
  },

  start(interval) {
    const _this = this;
    interval = interval || 1000;

    _timer = setInterval(() => {
      _this.eachStep();
    }, interval);
  },

  pause() {
    if (_timer) {
      clearInterval(_timer);
    }
  },
};

window.CountDown = CountDown;
export default CountDown;





// WEBPACK FOOTER //
// ./src/n_modules/mini-countdown/components/src/countdown.js